// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3GAGI","author":"Table_author__2WOxT","authorImage":"Table_authorImage__24PIp","unreadRow":"Table_unreadRow__111c-"};